export const makeSelectStudents = (state: AppState) => state.studentReducer.students;
export const makeSelectStudentsStatistics = (state: AppState) =>
  state.studentReducer.studentsStatistics;

// Lessons
export const makeSelectStudentLessons = (state: AppState) => state.studentReducer.studentLessonList;

export const makeSelectActiveTestScores = (state: AppState) =>
  state.studentReducer.activeTestScores;

export const makeSelectStudentTests = (state: AppState) => state.studentReducer.studentTests;

export const makeSelectStudentTestSections = (state: AppState) =>
    state.studentReducer.studentTestSections;
export const makeSelectStudentTestReportLink = (state: AppState) =>
    state.studentReducer.studentTestReportLink;
export const makeSelectStudentTestReportData = (state: AppState) =>
    state.studentReducer.studentTestReportData;

export const makeSelectStudentActiveLesson = (state: AppState) => state.studentReducer.activeLesson;

export const makeSelectActiveStudent = (state: AppState) => state.studentReducer.activeStudent;

export const makeSelectStudentSummary = (state: AppState) =>
  state.studentReducer.activeStudentSummary;

export const makeSelectStudentSessions = (state: AppState) => state.studentReducer.studentSessions;

export const makeSelectActiveStudentTest = (state: AppState) =>
  state.studentReducer.activeStudentTest;

// ///////Pre-Made Worksheet Selectors//////////////////////

export const makeSelectStudentWorksheets = (state: AppState) =>
  state.studentReducer.studentWorksheetList;

export const makeSelectActiveWorksheet = (state: AppState) => state.studentReducer.activeWorksheet;

export const makeSelectReportPreview = (state: AppState) => state.studentReducer.reportPreview;

export const makeSelectStudentActionSpinner = (state: AppState) =>
  state.studentReducer.studentActionSpinner;

export const makeSelectScoredTests = (state: AppState) => state.studentReducer.scoredTests;
export const makeSelectStudentTestPreviewPDF = (state: AppState) =>
  state.studentReducer.studentTestReportPdf;
